module.exports = __webpack_public_path__ + "img/WMS.c228b35f.svg";